import {useSearchParams} from "react-router-dom";
import {SLowcodeList} from "shj-components";
import {useEffect, useRef} from "react";

import {config} from './config.tsx'
import DesignDeptMnr from "@/pages/chatAssignOperation/components/DesignDeptMnr";
import {Button, message} from "antd";
import {assignEmployee, clueBizConver, queryClueEmployeeForReassign, queryEmployeePage} from "@/services/callCenter";
import {apiData2Table} from "@/utils/data.ts";
import {getClueDetail} from "@/services/saleOpServices.ts";
import {useSetState} from "ahooks";

const typeMap = {
  ['ASSIGN_SALES']: {
    title: '分配营销员',
    fetchListApi: queryEmployeePage,
    submitApi: assignEmployee,
  },
  ['ASSIGN_DESIGNER']: {
    title: '分配设计师',
    fetchListApi: queryEmployeePage,
    submitApi: assignEmployee,
  },
  ['ASSIGN_DESIGNER_MNR']: {
    title: '分配设计部经理',
    fetchListApi: queryClueEmployeeForReassign,
    submitApi: clueBizConver,
    isElement: true,
  },
}

const ChatAssignOperation = () => {
  const [search] = useSearchParams()
  const [buttonKey = 'ASSIGN_SALES', clueId = '1895127277386354689', trackPlanNodeId, trackPlanId] = search;
  const listRef = useRef()
  const tabRef = useRef()

  const [state, setState] = useSetState<any>({
    loading: false,
    clueInfo: {},
    selectedRows: [],
  })

  useEffect(() => {
    if(clueId) getInfo()
  }, [clueId]);

  const getInfo = () => {
    setState({loading: false})
    getClueDetail(clueId).then(res => {
      setState({clueInfo: res, loading: false})
    })
  }

  const fetchList = ({current, pageSize, query}) => {
    return new Promise((resolve, reject) => {
      typeMap[buttonKey].fetchListApi?.({
        params: {pageId: current, pageSize},
        data: {
          ...query,
          clueId,
          trackPlanNodeId,
          queryEmployee: true,
          queryOrg: true,
        }
      }).then(res => {
        resolve(apiData2Table(res))
      }).catch(reject)
    })
  }

  const onSubmit = async () => {
    try {
    let relatives;
    if (typeMap[buttonKey]?.isElement) {
      relatives = tabRef?.current?.getData?.()
    } else {
      if(!state.selectedRows?.[0]){
        message.error('请选择数据')
        return;
      }
    const data:Record<string, any> = state.selectedRows?.[0] || {}
      relatives = {
        ucenterUserId: data.ucenterUserId,
        name: data.userName,
        deptId: data?.orgId,
        companyId: data?.companyId,
        roleCode: data?.roleCode,
      }
    }
      const apiFn = typeMap[buttonKey].submitApi
      const res = await apiFn({
        clueId,
        buttonKey,
         trackPlanId,
        relatives
      });
      if (res.errorCode === 0 && res.status) {
        message.success(`${typeMap[buttonKey].title}成功`);
      } else {
        message.error(`${typeMap[buttonKey].title}失败`);
      }
    } catch (err) {
      console.log(err)
    }
  }

  const extensions = {
    request: {fetchList},
    rowSelection: {
      onChange: (_, selectedRows)=> {
        setState(selectedRows)
      }
    }
  }

  return <div style={{marginTop: 10}}>
    {typeMap[buttonKey]?.isElement ? <DesignDeptMnr fetchApi={typeMap[buttonKey].fetchListApi} trackPlanNodeId={1} clueId={2} ref={tabRef}/> :
        <SLowcodeList searchMode={'group'} ref={listRef} config={config} {...extensions}/>}
    <div style={{background: '#fff',borderTop: '2px solid #f6f8fb', padding: 20, display: 'flex', justifyContent: 'flex-end'}}>
      <Button>取消</Button>
      <Button type={'primary'} style={{marginLeft: 20}} onClick={onSubmit}>确认</Button>
    </div>
  </div>
}

export default ChatAssignOperation